import dayjs from 'dayjs';

export const COURSE_CATEGORY_SLUGS = ['confined-space', 'fall-protection', 'h2s-alive'];

export const COURSE_CATEGORY_NAMES = ['Confined Space', 'Fall Protection', 'H2S Alive'];

export const LOCATION_CATEGORY_NAMES = ['Kamloops', 'Kelowna', 'Nanaimo', 'Surrey', 'Vernon'];

const normalize = (str) => String(str || '').trim().toLowerCase();

export const getCalendarFetchRange = (maxDate) => ({
  startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
  endDate: dayjs(maxDate).isValid()
    ? dayjs(maxDate).format('YYYY-MM-DD')
    : dayjs().add(1, 'year').format('YYYY-MM-DD'),
});

export const parseTecEventDate = (dateStr) => {
  if (!dateStr) return dayjs(null);
  const match = String(dateStr).match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return dayjs(match[1]);
  return dayjs(dateStr);
};

export const decodeHtmlEntities = (text) => {
  if (!text) return '';

  let decoded = String(text);
  for (let i = 0; i < 3; i++) {
    const next = decoded
      .replace(/&a\/mp;/gi, '&')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#8211;/g, '–')
      .replace(/&nbsp;/g, ' ');
    if (next === decoded) break;
    decoded = next;
  }

  return decoded;
};

const isCourseCategory = (category) => {
  const slug = normalize(category?.slug);
  const name = normalize(category?.name);
  return (
    COURSE_CATEGORY_SLUGS.includes(slug) ||
    COURSE_CATEGORY_NAMES.some((n) => normalize(n) === name)
  );
};

const isLocationCategory = (category) => {
  const name = normalize(category?.name);
  return LOCATION_CATEGORY_NAMES.some((n) => normalize(n) === name);
};

export const eventHasCourseCategory = (event) => {
  const categories = Array.isArray(event?.categories) ? event.categories : [];
  return categories.some(isCourseCategory);
};

export const getEventLocation = (event) => {
  const categories = Array.isArray(event?.categories) ? event.categories : [];
  const loc = categories.find(isLocationCategory);
  return loc?.name || '';
};

export const mapEventToCalendarSlot = (event) => {
  const start = event.start_date || '';
  return {
    event_id: event.id,
    product_id: event.id,
    product_name: decodeHtmlEntities(event.title),
    event_slug: event.slug || '',
    date: start,
    calendarDay: start.substring(0, 10),
    url: event.url || '',
    location: getEventLocation(event),
  };
};

export const mapEventsToCalendarSlots = (events) => {
  if (!Array.isArray(events)) return [];
  return events.filter(eventHasCourseCategory).map(mapEventToCalendarSlot);
};
